import { render } from "./ScannedPDFViewer.vue?vue&type=template&id=2788f74e&scoped=true"
import script from "./ScannedPDFViewer.vue?vue&type=script&lang=js"
export * from "./ScannedPDFViewer.vue?vue&type=script&lang=js"

import "./ScannedPDFViewer.vue?vue&type=style&index=0&id=2788f74e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2788f74e"]])

export default __exports__